import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IIcon } from '../../../shared/components/icon/icon.interface';

@Component({
  selector: 'app-picker-dialog-list-item',
  templateUrl: './picker-dialog-list-item.component.html',
  styleUrls: ['./picker-dialog-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickerDialogListItemComponent implements OnInit {
  @Input() bulkActionControl: AbstractControl;
  @Input() bulkActionFieldId: string;
  @Input() showHeader: boolean;
  @Input() header: string;
  @Input() headerIcon: IIcon;
  @Input() description: string;
  @Input() subDescription: string;

  @Output() onClickListItem: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('click')
  onClick() {
    this.onClickListItem.emit();
  }

  constructor() {}

  ngOnInit() {}
}
